// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroParallax_wrapper__Ej8CQ","image":"HeroParallax_image__AtX4h","parallaxItem":"HeroParallax_parallaxItem__k0O1f"};